// extracted by mini-css-extract-plugin
export default {"badge-button":"PlaF5","badgeButton":"PlaF5","badge":"_3sAlw"};